"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
const LinkedList_1 = require("./LinkedList");
const BasicEnumerable_1 = require("../enumerables/BasicEnumerable");
const EnumerableFactory_1 = require("../utilities/EnumerableFactory");
const utilityFunctions_1 = require("../utilities/utilityFunctions");
class Queue extends BasicEnumerable_1.BasicEnumerable {
    constructor(collection) {
        const list = new LinkedList_1.LinkedList();
        super(new EnumerableFactory_1.EnumerableFactory(), (0, utilityFunctions_1.getIterableGenerator)(list));
        this.list = list;
        for (const item of collection !== null && collection !== void 0 ? collection : []) {
            this.enqueue(item);
        }
    }
    get length() {
        return this.list.length;
    }
    clear() {
        this.list.clear();
    }
    copyTo(array, arrayIndex) {
        let i = arrayIndex;
        for (const item of this) {
            array[i] = item;
            i++;
        }
    }
    dequeue() {
        const first = this.tryDequeue();
        if (first === null) {
            throw new Error('Queue contains no elements');
        }
        return first;
    }
    enqueue(item) {
        this.list.addLast(item);
    }
    peek() {
        const first = this.tryPeek();
        if (first === null) {
            throw new Error('Queue contains no elements');
        }
        return first;
    }
    tryDequeue() {
        var _a;
        const first = this.list.firstListNode;
        this.list.removeFirst();
        return (_a = first === null || first === void 0 ? void 0 : first.value) !== null && _a !== void 0 ? _a : null;
    }
    tryPeek() {
        var _a;
        const first = this.list.firstListNode;
        return (_a = first === null || first === void 0 ? void 0 : first.value) !== null && _a !== void 0 ? _a : null;
    }
}
exports.Queue = Queue;
//# sourceMappingURL=Queue.js.map